import { INTEREST_DATA, INTEREST_ERROR_DATA, INTEREST_HIDE_ERROR_DATA, INTEREST_START_LOADER, INTEREST_STOP_LOADER, } from "../interface/iInterestRates";
const initialState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const interest = (state = initialState, action) => {
    switch (action.type) {
        case INTEREST_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case INTEREST_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case INTEREST_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case INTEREST_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case INTEREST_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default interest;
